module.exports = __webpack_public_path__ + "static/BNP-e6dbaedb8f278feb3d734b4e79a97c42.png";